import { Dispatch, FC, memo, SetStateAction } from 'react'
import { Box, Button, SimpleGrid } from '@chakra-ui/react'

import { Grid3x3 } from 'components/icons'
import { CATEGORIES_OBJECT, CATEGORIES_OPTIONS } from 'constants/variables'

type Props = {
  name: string
  filter: any
  setFilter: Dispatch<SetStateAction<any>>
}

const CategoriesFilter: FC<Props> = ({ name = '', filter, setFilter }) => {
  function handleChangeCategory(category: string) {
    setFilter({ ...filter, [name]: category })
  }

  function isSelectedCategory(category: string) {
    return filter[name] === category
  }

  return (
    <SimpleGrid columns={[2, 2, 3, 3, 6, 6]} spacing={2}>
      <Box>
        <Button
          colorScheme="primary"
          leftIcon={<Grid3x3 color={isSelectedCategory('') ? 'light' : 'primary.600'} />}
          onClick={() => handleChangeCategory('')}
          variant={isSelectedCategory('') ? 'solid' : 'outline'}
          w="full"
        >
          Todos
        </Button>
      </Box>
      {CATEGORIES_OPTIONS.map(({ value }) => {
        if (!value) return null
        const { Icon, color, name } = CATEGORIES_OBJECT[value]

        return (
          <Box key={value}>
            <Button
              onClick={() => handleChangeCategory(value)}
              colorScheme={color}
              leftIcon={<Icon color={isSelectedCategory(value) ? 'light' : `${color}.600`} />}
              variant={isSelectedCategory(value) ? 'solid' : 'outline'}
              w="full"
            >
              {name}
            </Button>
          </Box>
        )
      })}
    </SimpleGrid>
  )
}

export default memo(CategoriesFilter)
